module.exports = __webpack_public_path__ + "img/scans.78a9bf6a.svg";